import React, { Component } from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { Button } from "reactstrap";
import { Link } from "react-router-dom";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { connect } from "react-redux";
import style from "./SubCategoryList.module.css";
import { fetchSubCategoryList } from "../../redux";
import ttmLodader from "../../assets/images/ttm-loader.gif";
import api from "../../utils/Api";
import history from "../../utils/history";

export class SubCategoryList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      sub_category_id: "",
      searchKey: "",
      page: 1,
      sortName: undefined,
      sortOrder: undefined,
      sortBy: "",
      isEditMode: "",
      isDataFetched: false,
      isModalOpen: false,
      successMessage: "",
      errorMessage: "",
      subCategoryList: []
    };
    this.setLoader = this.setLoader.bind(this);
  }
  // Adding actions edit and delete icons
  actionsFormatter(cell, row) {
    //console.log("+++++sub category list ", row);
    return (
      <div>
        <Link title="Edit Subcategory"
          to={{
            pathname: `/app/subcategorieslist/${row.sub_category_id}`,
            state: row,
          }}
        >
          <i class="fa fa-pencil-square-o mr-3 relatedpartylist-edit-icon"></i>
        </Link>
        <Link title="Delete Subcategory"
          class="action-icons relatedpartylist-add-icon"
          onClick={() => this.toggle(row)}
        >
          <i class="fa fa-trash"></i>
        </Link>
      </div>
    );
  }

  componentDidMount = async() => {
    document.title = 'Subcategories - TechToMedix';
    await this.props.fetchSubCategoryList(
      this.state.searchKey,
      this.state.sortBy,
      this.state.page
    );
    if(this.props.subcategoryListData && 
      this.props.subcategoryListData.subcategoryList && 
      this.props.subcategoryListData.subcategoryList.subCategory){
        this.setState({
          subCategoryList: this.props.subcategoryListData.subcategoryList.subCategory
        })
    }
    setTimeout(() => {
      if (this.props.subcategoryListData.subcategoryList.total === 0) {
        this.setState({
          isDataFetched: true,
        });
      } else {
        this.setState({
          isDataFetched: false,
        });
        setTimeout(() => {
          this.setState({
            isDataFetched: true,
          });
        }, 500);
      }
    }, 1000);
  }

  callSubCategoryListAPI = async()=> {
    this.setState({
      subCategoryList: []
    })
  
    await this.props.fetchSubCategoryList(
      this.state.searchKey,
      this.state.sortBy,
      this.state.page
    );
    if(this.props.subcategoryListData && !this.props.subcategoryListData.loading){
          if(this.props.subcategoryListData.subcategoryList && 
              this.props.subcategoryListData.subcategoryList.subCategory){
          this.setState({
            subCategoryList: this.props.subcategoryListData.subcategoryList.subCategory
          })
        }
      setTimeout(() => {
        this.setState({
          isDataFetched: true,
        });
    }, 1000);
    }
  
  }

  toggle = (val) => {
    this.setState((prevState) => ({
      sub_category_id: val.sub_category_id,
      isModalOpen: !prevState.isModalOpen,
    }));
  };

  onSortChange = (sortName, sortOrder) => {
    let sortBy;
    if (sortOrder == "desc") {
      sortBy = "-" + sortName;
    } else {
      sortBy = sortName;
    }
    this.setState({
      sortName,
      sortOrder,
      sortBy,
      page: 1,
      isDataFetched: false,
    },()=>{
      this.callSubCategoryListAPI();
    });
  };

  onSearchChange = (event) => {
    this.setState({ searchKey: event.target.value, page: 1, isDataFetched: false },()=>{
        this.callSubCategoryListAPI();
    });
  };

  onPageChange = (page, sizePerPage) => {
    this.setState({ page, isDataFetched: false },()=>{
      this.callSubCategoryListAPI();
    });
  };

  setLoader() {
    if (this.state.isDataFetched) {
      return <p>There is no data to display</p>;
    } else {
      return (
        <div>
          <img src={ttmLodader} className="loader-image" />
        </div>
      );
    }
  }

  // Delete API calling
  onDeleteSubCategory = async () => {
    try {
      const response = await api.delete("inventory/subcategory", {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
        },
        data: {
          sub_category_id: this.state.sub_category_id,
        },
      });
      if (response.status === 200) {
        this.setState({
          successMessage: "Subcategory deleted successfully!",
        });
        setTimeout(() => {
          this.setState((prevState) => ({
            successMessage: "",
            isModalOpen: !prevState.isModalOpen,
          }));
            this.callSubCategoryListAPI();
        }, 3000);
      }
    } catch (error) {
      this.setState({
        errorMessage: "Internal server error occurred",
      });
      setTimeout(() => {
        this.setState((prevState) => ({
          errorMessage: "",
        }));
      }, 3000);
    }
  };

  goBack = () => {
    history.goBack();
  }
  render() {
    const subcategoryList = this.props.subcategoryListData.subcategoryList;

    return (
      <div className={style.roomListMainWarapper}>
         {this.props.location.state && 
      this.props.location.state.fromNotifications === 1 &&  ( 
        <div className="mb-2">
            <span className="goBackBtn" onClick={this.goBack}>
              <i class="fa fa-arrow-left" aria-hidden="true"></i>{" "}
              Go Back to Notifications</span>
          </div>)}
        <div className="row">
          <div className="col-lg-7">
            <h3>Sub Categories list</h3>
          </div>
          <div
                className={`col-md-5 order-3 order-md-2 d-flex justify-content-start justify-content-md-end `}
              >
               <div className="form-group">
                  <input
                    type="text"
                    className={`form-control ${style.inputSearch}`}
                    id="search"
                    placeholder="Search here"
                    value={this.state.searchKey}
                    onChange={this.onSearchChange}
                  />
                </div>
              </div>
          {/* <div className={`col ${style.addRoleBtnWrapper}`}>
            <Link to="/app/roomcreation">
              <Button color="primary" className={style.addBtn}>
                <i className="fa fa-plus mr-2"></i>ADD ROOM
              </Button>
            </Link>
          </div> */}
        </div>
        <div className="row">
        <div className="col-lg-12 intro-text">
            <p className="mb-4">
              This is list of all subcategories available on the system. Edit
              and delete actions are given. Search filter is given on top to
              search sub category namesThis is list of all subcategories
              available on the system. Edit and delete actions are given. Search
              filter is given on top to search sub category names
            </p>
          </div>
        </div>
        <BootstrapTable
          bordered={false}
          remote={true}
          data={this.state.subCategoryList}
          version="4"
          search={false}
          pagination
          fetchInfo={{
            dataTotalSize: this.props.subcategoryListData.subcategoryList.total,
          }}
          options={{
            sortName: this.state.sortName,
            sortOrder: this.state.sortOrder,
            onSortChange: this.onSortChange,
            onSearchChange: this.onSearchChange,
            sizePerPage: 10,
            page: this.state.page,
            onPageChange: this.onPageChange,
            noDataText: this.setLoader(),
          }}
        >
          <TableHeaderColumn
            dataField="sub_category_name"
            isKey
            dataSort={true}
          >
            Sub Category Name
          </TableHeaderColumn>
          <TableHeaderColumn dataField="product_count" dataSort={true}>
            No. of Products
          </TableHeaderColumn>
          <TableHeaderColumn dataField="category_name" dataSort={true}>
            Category
          </TableHeaderColumn>
          <TableHeaderColumn dataField="upper_threshold" dataSort={true}>
            Threshold (Max)
          </TableHeaderColumn>
          <TableHeaderColumn dataField="lower_threshold" dataSort={true}>
            Threshold (Min)
          </TableHeaderColumn>

          <TableHeaderColumn
            dataField="actions"
            dataFormat={this.actionsFormatter.bind(this)}
            width="20%"
          >
            Actions
          </TableHeaderColumn>
        </BootstrapTable>
        {/* Open a modal for delete procedure */}
        <Modal
          isOpen={this.state.isModalOpen}
          toggle={this.toggle}
          className={style.deleteReason}
          centered
        >
          <ModalHeader toggle={this.toggle} className={style.deleteModalHeader}>
            Delete Sub Category
          </ModalHeader>
          <ModalBody>
            <div className={style.deleteReasonHeadingWrapper}>
              <p>
                Please confirm whether you want to delete this Sub Category.
              </p>
            </div>
            <div className={style.deleteReasonFormWrapper}>
              <form onSubmit={this.onSubmit}>
                <div className={style.error}>{this.state.errorField}</div>
                <div className="row">
                  <div className={`col-md-12 ${style.deleteBtnWrapper}`}>
                    <button
                      type="button"
                      className="ttm-primary-btn"
                      onClick={this.onDeleteSubCategory}
                    >
                      Delete
                    </button>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    {this.state.successMessage && (
                      <p className={style.successMessage}>
                        {this.state.successMessage}
                      </p>
                    )}
                    {this.state.errorMessage && (
                      <p className={style.errorMessage}>
                        {this.state.errorMessage}
                      </p>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    subcategoryListData: state.subcategoryList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchSubCategoryList: (searchKey, sortBy, page) =>
      dispatch(fetchSubCategoryList(searchKey, sortBy, page)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SubCategoryList);
